import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import { useNavigate } from "react-router-dom";
import bookkeepingImage from "../../images/bookkeeping_payroll.png"; // Make sure image path is correct

const Bookkeeping = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Bookkeeping & Payroll Services</h1>

        <div className="cap-section">
          {/* Text Section */}
          <div className="text-content">
          <h2>Accurate Bookkeeping and Payroll Services That Allow For Easy Money Management</h2>
          <p>
            Managing finances in a healthcare practice requires accuracy, organization, and compliance.
            At S&S Healthcare Consulting, we provide comprehensive bookkeeping and payroll services to ensure seamless financial operations.
            From tracking expenses and reconciling accounts to processing payroll and managing tax withholdings,
            we handle the details so you can focus on patient care.
          </p>
          <p>
            Our services help practices maintain financial stability, ensure timely and accurate employee compensation,
            and stay compliant with ever-changing regulations.
            Let us simplify your financial management, giving you peace of mind and more time to focus on what matters most—your patients.
          </p>

            <button className="cap-button" onClick={() => navigate("/learn-more/bookkeeping")}>Learn More</button>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={bookkeepingImage} alt="Medical Billing" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Bookkeeping;
